// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"444d64468f1abc18","7308":"d71cff0ba519278b"}[chunkId] + ".css";
};